/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BytesResult } from '../../models/bytes-result';

export interface ExportMultiplePdfWorkPackage$Params {
  projectId: string;
  workPackageIds?: Array<string>;
  parentId?: string;
  query?: string;
  createdById?: string | null;
  assigneeIds?: Array<string>;
  typeIds?: Array<string>;
  priorityIds?: Array<string>;
  statusIds?: Array<string>;
  categoriesIds?: Array<string>;
  groupsIds?: Array<string>;
  dynamicFilters?: string;
  isExpired?: boolean | null;
  startFrom?: string | null;
  startTo?: string | null;
  endFrom?: string | null;
  endTo?: string | null;
  zipName?: string;
}

export function exportMultiplePdfWorkPackage(http: HttpClient, rootUrl: string, params: ExportMultiplePdfWorkPackage$Params, context?: HttpContext): Observable<StrictHttpResponse<BytesResult>> {
  const rb = new RequestBuilder(rootUrl, exportMultiplePdfWorkPackage.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('workPackageIds', params.workPackageIds, {});
    rb.query('parentId', params.parentId, {});
    rb.query('query', params.query, {});
    rb.query('createdById', params.createdById, {});
    rb.query('assigneeIds', params.assigneeIds, {});
    rb.query('typeIds', params.typeIds, {});
    rb.query('priorityIds', params.priorityIds, {});
    rb.query('statusIds', params.statusIds, {});
    rb.query('categoriesIds', params.categoriesIds, {});
    rb.query('groupsIds', params.groupsIds, {});
    rb.query('dynamicFilters', params.dynamicFilters, {});
    rb.query('isExpired', params.isExpired, {});
    rb.query('startFrom', params.startFrom, {});
    rb.query('startTo', params.startTo, {});
    rb.query('endFrom', params.endFrom, {});
    rb.query('endTo', params.endTo, {});
    rb.query('zipName', params.zipName, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BytesResult>;
    })
  );
}

exportMultiplePdfWorkPackage.PATH = '/v0/workPackages/export-pdf';
